import { formatNumber } from '@angular/common';
import { CartTableRow } from './cart-table.model';
import { AdminCart } from '../../../../../pages/admin-dashboard/cart-management/admin-cart.model';


function toCartTableRow(
  cart: AdminCart,
  index: number,
  isArabic: boolean,
  offset: number,
  locale: string,
): CartTableRow {
  return {
    id: cart.id,
    index: offset + index + 1,
    cartTitle: cart.cartTitle || '—',
    pharmacy: cart.pharmacy?.nickName ?? '—',
    pharmacyOwner: cart.pharmacy?.pharmacyOwner?.fullName ?? '',
    totalItems: `${cart.totalItems} ${isArabic ? 'صنف' : 'items'}`,
    totalQuantity: `${cart.totalQuantity} ${isArabic ? 'عناصر' : 'units'}`,
    totalPrice: `${formatNumber(cart.totalPrice, locale, '1.2-2')} ${isArabic ? 'ج.م' : 'EGP'}`,
    createdOn: cart.createdOn,
    createdBy: cart.createdBy?.fullName ?? '—',
    lastModifiedOn: cart.lastModifiedOn ?? null,
    lastModifiedBy: cart.lastModifiedBy?.fullName ?? null,
    assignedTo: cart.assignedTo?.fullName ?? '—',
  };
}

export function toCartTableRows(
  carts: AdminCart[],
  isArabic: boolean,
  currentPage: number, 
  itemsPerPage: number,
  locale: string,
): CartTableRow[] {
  const offset = (currentPage - 1) * itemsPerPage;
  return carts.map((c, i) => toCartTableRow(c, i, isArabic, offset, locale));
}
